import { render, staticRenderFns } from "./ValidatedGroup.vue?vue&type=template&id=181ae651"
import script from "./validatedGroup.ts?vue&type=script&lang=ts&external"
export * from "./validatedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181ae651')) {
      api.createRecord('181ae651', component.options)
    } else {
      api.reload('181ae651', component.options)
    }
    module.hot.accept("./ValidatedGroup.vue?vue&type=template&id=181ae651", function () {
      api.rerender('181ae651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/groups/client/validated-group/ValidatedGroup.vue"
export default component.exports